/**
 * Who may record an audit decision, mirroring `canAct()` in
 * `backend/src/controllers/release_audit.js`.
 *
 * The UI uses this only to explain why the Approve / Flag buttons are disabled;
 * the server is still the one that refuses the request. Roles arrive as
 * "Auditor General" / "Auditor" from User Management, so they are normalised the
 * same way the backend does it.
 */
export const normaliseAuditRole = (role) =>
  String(role || "")
    .trim()
    .toLowerCase()
    .replace(/[\s_-]/g, "");

export const isAuditorGeneralAccount = (user) =>
  normaliseAuditRole(user?.role) === "auditorgeneral";

export const isReleaseAuditorAccount = (user) =>
  normaliseAuditRole(user?.role) === "auditor";

export const hasAdminAccess = (user) =>
  normaliseAuditRole(user?.role) === "admin" ||
  String(user?.accessTo || "")
    .split(",")
    .some((entry) => entry.trim().toLowerCase() === "admin");

/** Same separation as the server: the AG cannot action stage 2, an auditor cannot action stage 1. */
export const canActAtStage = (user, stage) => {
  if (stage === 1) {
    if (isReleaseAuditorAccount(user)) return false;
    return hasAdminAccess(user) || isAuditorGeneralAccount(user);
  }

  if (isAuditorGeneralAccount(user)) return false;
  return hasAdminAccess(user) || isReleaseAuditorAccount(user);
};

export const STAGE_ACTOR = {
  1: "Auditor General",
  2: "release auditor",
};
